module.exports = __webpack_public_path__ + "static/img/7.ff712a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/7.png
// module id = Mq/6
// module chunks = 0